import React, {
  Component
} from 'react';
import {
  hashHistory
} from 'react-router';
import {protocolCode ,bankCode} from '../../BankCode';
/*弹出框*/
class AlerModle extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount() {
    document.getElementsByTagName('html')[0].style.overflowY='hidden';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentWillUnmount(){
    document.getElementsByTagName('html')[0].style.overflowY='auto';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
  }
  goBack() {
    hashHistory.goBack();
    // this.props.history.push({
    //     pathname:'/',
    // })
  }
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  render() {
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    return (
      <div className="AlerModle_DIV" onClick={(event)=>{ event.stopPropagation(); return false }} onTouchMove={this.touchmove.bind(this)} onTouchStart={()=> { return false; }} >
    <div style={{ width:"300px", background:"#FFF", borderRadius:"20px", position:"relative" }}>
            <div className="AlertIcon">
              <span></span>
            </div>
            <div className="closeIcon" onClick={ ()=>{ this.props.CloseAler() } }>
              
            </div>
            <div style={{ paddingLeft:"20px", paddingRight:"20px", marginTop:"-12px" }}>
              <div style={{textAlign:"center", marginBottom:"20px", fontSize:17 }}>查理解密</div>
              <div style={{ fontSize:15, lineHeight:"20px" }}>
                { this.props.content }
              </div>
              <div style={{ height:"30px" }}></div>
              <div className="alertOk_div">
                <div onClick={ ()=>{ this.props.CloseAler() } }style={{borderRadius:"20px", width:"210px", backgroundColor:"#fa063a", height:"40px", color:"#FFF", textAlign:"center", lineHeight:"40px" }}>
                  知道了
                </div>
              </div>
              <div style={{height:"40px"}}></div>
            </div>
          </div>
        </div>
    );
  }
}


export class AlerModleLcs extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount() {
    document.getElementsByTagName('html')[0].style.overflowY='hidden';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentWillUnmount(){
    document.getElementsByTagName('html')[0].style.overflowY='auto';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
  }
  goBack() {
    hashHistory.goBack();
    // this.props.history.push({
    //     pathname:'/',
    // })
  }
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  render() {
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    return (
      <div className="AlerModle_DIV" onClick={(event)=>{ event.stopPropagation(); return false }} onTouchmove={this.touchmove.bind(this)} onTouchstart={()=> { return false; }} >
     <div style={{ width:"300px", background:"#FFF", borderRadius:"10px", position:"relative" }}>
       
            <div>
      
              <div className="alertContent">
                { this.props.content }
              </div>
              <div className="alertSureBtn" onClick={ ()=>{ this.props.CloseAler() } }>
                确认
              </div>
            </div>
          </div>
        </div>
    );
  }
}


export class AlerModleQy extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isSelected: false,
    };
  }
  componentWillMount() {
    document.getElementsByTagName('html')[0].style.overflowY='hidden';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentWillUnmount(){
    document.getElementsByTagName('html')[0].style.overflowY='auto';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
  }
  goBack() {
    hashHistory.goBack();
    // this.props.history.push({
    //     pathname:'/',
    // })
  }
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  handleClick1(){
    if(this.props.handleClick1 && this.state.isSelected ){
      this.props.handleClick1()
    }
  }
  handleClick2(){
    if(this.props.handleClick2){
      this.props.handleClick2()
    }
  }
  ProtocolPaper(name){
    let code=protocolCode[name];
    console.log(hashHistory)
    hashHistory.push({
        pathname:'/WebView',
        state:{name:name,code:code},
        query: {code:code}
    })
  }
  render() {
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    return (
      <div className="AlerModle_DIV" onClick={(event)=>{ event.stopPropagation(); return false }} onTouchmove={this.touchmove.bind(this)} onTouchstart={()=> { return false; }} >
        <div style={{ width:"300px", background:"#FFF", borderRadius:"20px", position:"relative" }}>
            <div className="AlertIcon">
              <span></span>
            </div>
            {/*
              <div className="closeIcon" onClick={ ()=>{ this.props.CloseAler() } }>
                
              </div>
            */}
            <div style={{ paddingLeft:"10px", paddingRight:"10px", marginTop:"-12px" }}>
              <div style={{textAlign:"center", marginBottom:"20px", fontSize:15 }}>签约提醒</div>
              <div style={{ fontSize:12, lineHeight:"20px" }}>
                  <p>尊敬的客户，你好！华夏财富获批成为基金投资顾问业务首批试点机构，查理智投服务升级为基金投顾服务。同意签约后，您将享受以下服务：</p>
                  <p>1、实时自动调仓，避免仓位偏移;</p>  
                  <p>2、组合内成分基金申购费低至0折，降低交易成本;</p>
                  <p>3、全市场基金配置，配置策略更灵活；</p>
                  <p>基金投资顾问业务将收取投资顾问服务费，请您认真阅读投资顾问服务协议。如同意，请及时签约并将持有的组合转换为最新组合。</p>
              
              </div>
              <div style = {{
              WebkitFlexDirection: 'row',
              WebkitJustifyContent: 'center', 
              marginTop: 15,
              marginLeft: 0,
              marginRight: 13,
              display: "-webkit-flex"
          }}>
            <div onClick = {()=>{this.setState({isSelected: !this.state.isSelected})}}>
            {
              this.state.isSelected ? 
              <img style={{
                height: 44,
                width: 44,
                marginTop: -9,
                marginLeft: -13
              }} src={require('../../img/protocol_selected.png')} />
              :
              <img style={{
                height: 44,
                width: 44,
                marginTop: -9,
                marginLeft: -13
              }} src={require('../../img/square.png')} />
            }
            </div>
            <span style = {{
              marginTop: 3,
              marginLeft: -7,
              WebkitFlex: 1,
              color: '#a1a7b2',
              fontSize: 12,
              lineHeight: "20px"
            }}>我已阅读并同意<span style={{color:'#fa063a'}} onClick={()=>this.ProtocolPaper('上海华夏财富投资管理有限公司基金投资顾问服务协议')}>《上海华夏财富投资管理有限公司基金投资顾问服务协议》</span> </span>
          </div>
              <div style={{ height:"20px" }}></div>
              <div className="alertOk_div">
                <div onClick={ ()=>{ this.handleClick1() } }style={{borderRadius:"20px", width:"210px", backgroundColor:this.state.isSelected ? "#fa063a" : "#CCC", height:"40px", color:"#FFF", textAlign:"center", lineHeight:"40px" }}>
                  同意签约
                </div>
              </div>
              <div className="alertOk_div" style={{marginTop:10}}>
                <div onClick={ ()=>{ this.handleClick2() } }style={{borderRadius:"20px", width:"210px", border:"1px solid #CCC",backgroundColor:"#FFF", height:"40px", color:"#000", textAlign:"center", lineHeight:"40px" }}>
                  暂不签约
                </div>
              </div>
              <div style={{height:"20px"}}></div>
            </div>
          </div>
        </div>
    );
  }
}


export class AlerModleCommon extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isSelected: false,
    };
  }
  componentWillMount() {
    document.getElementsByTagName('html')[0].style.overflowY='hidden';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentWillUnmount(){
    document.getElementsByTagName('html')[0].style.overflowY='auto';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
  }
  goBack() {
    hashHistory.goBack();
    // this.props.history.push({
    //     pathname:'/',
    // })
  }
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  render() {
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    let { handleClick1, handleClick2, btnTxt1, btnTxt2, title } = this.props;
    return (
      <div className="AlerModle_DIV" onClick={(event)=>{ event.stopPropagation(); return false }} onTouchmove={this.touchmove.bind(this)} onTouchstart={()=> { return false; }} >
    <div style={{ width:"300px", background:"#FFF", borderRadius:"20px", position:"relative" }}>
            <div className="AlertIcon">
              <span></span>
            </div>
            {
              /*
                <div className="closeIcon" onClick={ ()=>{ this.props.CloseAler() } }>
                </div>
              */
            }

            <div style={{ paddingLeft:"10px", paddingRight:"10px", marginTop:"-12px" }}>
              <div style={{textAlign:"center", marginBottom:"20px", fontSize:15 }}>{ title }</div>
              {
                this.props.contentArr ?
                this.props.contentArr.map((data, index) => {
                  return (
                    <div key={index} style={{ fontSize:13, lineHeight:"20px" }}>
                      {data}
                    </div>
                  )
                })
                :
                <div style={{ fontSize:13, lineHeight:"20px" }}>
                    { this.props.content }
                </div>
              }
              {
                this.props.contentSec ?
                <div style={{ fontSize:13, lineHeight:"20px" }}>
                    { this.props.contentSec }
                </div>
                :
                null
              }
              
              <div style={{ height:"20px" }}></div>
              {
                 this.props.btnTxt1 ? 
                 <div className="alertOk_div">
                    <div onClick={ ()=>{ handleClick1() } }style={{fontSize:"0.3rem",borderRadius:"20px", width:"210px", backgroundColor:"#fa063a", height:"40px", color:"#FFF", textAlign:"center", lineHeight:"40px" }}>
                      { this.props.btnTxt1 }
                    </div>
                  </div> : null 
              }
              
              {
                this.props.btnTxt2 ? 
                <div className="alertOk_div" style={{marginTop:10}}>
                  <div onClick={ ()=>{ handleClick2() } }style={{fontSize:"0.3rem",borderRadius:"20px", border:"1px solid #CCC", width:"210px", backgroundColor:"#FFF", height:"40px", color:"#000", textAlign:"center", lineHeight:"40px" }}>
                    { this.props.btnTxt2 }
                  </div>
                </div> : null
              }
              
              <div style={{height:"30px"}}></div>
            </div>
          </div>
        </div>
    );
  }
}

export class AlerModleCommonn extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isSelected: false,
    };
  }
  componentWillMount() {
    document.getElementsByTagName('html')[0].style.overflowY='hidden';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentWillUnmount(){
    document.getElementsByTagName('html')[0].style.overflowY='auto';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
  }
  goBack() {
    hashHistory.goBack();
    // this.props.history.push({
    //     pathname:'/',
    // })
  }
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  render() {
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    let { handleClick1, handleClick2, btnTxt1, btnTxt2, title } = this.props;
    return (
      <div className="AlerModle_DIV" onClick={(event)=>{ event.stopPropagation(); return false }} onTouchmove={this.touchmove.bind(this)} onTouchstart={()=> { return false; }} >
    <div style={{ width:"300px", background:"#FFF", borderRadius:"20px", position:"relative" }}>
            {
              /*
                <div className="closeIcon" onClick={ ()=>{ this.props.CloseAler() } }>
                </div>
              */
            }

            <div style={{  marginTop:"15px" }}>
              {
                this.props.contentArr ?
                this.props.contentArr.map((data, index) => {
                  return (
                    <div key={index} style={{ fontSize:13, lineHeight:"20px",paddingLeft:"20px", paddingRight:"20px", }}>
                      {data}
                    </div>
                  )
                })
                :
                <div style={{ fontSize:13, lineHeight:"20px",paddingLeft:"20px", paddingRight:"20px", }}>
                    { this.props.content }
                </div>
              }
              {
                this.props.contentSec ?
                <div style={{ fontSize:13, lineHeight:"20px",paddingLeft:"20px", paddingRight:"20px", }}>
                    { this.props.contentSec }
                </div>
                :
                null
              }
              {
                 this.props.btnTxt1 ? 
                 <div className="alertOk_div">
                    <div onClick={ ()=>{ handleClick1() } }style={{fontSize:"0.32rem", width:"100%", height:"40px",color:'#666666', textAlign:"center", lineHeight:"40px",borderTopColor:"#ebeef0",borderTopWidth:"1px",borderTopStyle:"solid",marginTop:"15px" }}>
                      { this.props.btnTxt1 }
                    </div>
                  </div> : null 
              }
              
              {
                this.props.btnTxt2 ? 
                <div className="alertOk_div" style={{marginTop:10}}>
                  <div onClick={ ()=>{ handleClick2() } }style={{fontSize:"0.32rem",borderRadius:"20px", border:"1px solid #CCC", width:"210px", backgroundColor:"#FFF", height:"40px", color:"#000", textAlign:"center", lineHeight:"40px" }}>
                    { this.props.btnTxt2 }
                  </div>
                </div> : null
              }
            </div>
          </div>
        </div>
    );
  }
}

export class AlerModleUpgrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isSelected: false,
    };
  }
  componentWillMount() {
    document.getElementsByTagName('html')[0].style.overflowY='hidden';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentWillUnmount(){
    document.getElementsByTagName('html')[0].style.overflowY='auto';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
  }
  goBack() {
    hashHistory.goBack();
    // this.props.history.push({
    //     pathname:'/',
    // })
  }
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  render() {
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    let { handleClick1, handleClick2, btnTxt1, btnTxt2, title } = this.props;
    return (
      <div className="AlerModle_DIV" onClick={(event)=>{ event.stopPropagation(); return false }} onTouchmove={this.touchmove.bind(this)} onTouchstart={()=> { return false; }} >
    <div style={{ width:"300px", background:"#FFF", borderRadius:"20px", position:"relative" }}>
            <div className="AlertIcon">
              <span></span>
            </div>
            {
              /*
                <div className="closeIcon" onClick={ ()=>{ this.props.CloseAler() } }>
                </div>
              */
            }

            <div style={{ paddingLeft:"10px", paddingRight:"10px", marginTop:"-12px" }}>
              <div style={{textAlign:"center", marginBottom:"20px", fontSize:15 }}>{ title }</div>
              <div style={{ fontSize:13, lineHeight:"20px" }}>
                  感谢您的信任，已为您开立基金投顾账户。   华夏财富获批成为基金投资顾问业务首批试点机构，即日起查理智投全新升级。您可将持有的<span style={{color:"red"}}>{ this.props.content }</span>转换为与您风险承受能力匹配的组合，享受基金投顾服务。
              </div>
              
              <div style={{ height:"20px" }}></div>
              {
                 this.props.btnTxt1 ? 
                 <div className="alertOk_div">
                    <div onClick={ ()=>{ handleClick1() } }style={{fontSize:"0.3rem",borderRadius:"20px", width:"210px", backgroundColor:"#fa063a", height:"40px", color:"#FFF", textAlign:"center", lineHeight:"40px" }}>
                      { this.props.btnTxt1 }
                    </div>
                  </div> : null 
              }
              
              {
                this.props.btnTxt2 ? 
                <div className="alertOk_div" style={{marginTop:10}}>
                  <div onClick={ ()=>{ handleClick2() } }style={{fontSize:"0.3rem",borderRadius:"20px", border:"1px solid #CCC", width:"210px", backgroundColor:"#FFF", height:"40px", color:"#000", textAlign:"center", lineHeight:"40px" }}>
                    { this.props.btnTxt2 }
                  </div>
                </div> : null
              }
              
              <div style={{height:"30px"}}></div>
            </div>
          </div>
        </div>
    );
  }
}

export class ModalTips extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabledFlag: false,
			disabledNum: 10
    };
    this.interval = null;
  }
  componentWillMount() {
    // document.getElementsByTagName('html')[0].style.overflowY='hidden';
    // document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentDidMount(){
    let num = this.state.disabledNum;
	    this.interval = setInterval(() => {
	    	if(this.state.disabledNum - 1 == 0) {
	    		this.setState({
	    			disabledFlag: true,
            disabledNum: 0
	    		});
	    		clearInterval(this.interval);
	    	}else {
          this.setState({
            disabledNum: this.state.disabledNum - 1
          });
        }
	    }, 1000)
  }
  componentWillUnmount(){
    // document.getElementsByTagName('html')[0].style.overflowY='auto';
    // document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
      if(this.interval) {
        clearInterval(this.interval);
      }
  }
 
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  goBack() {
    hashHistory.goBack();
    // this.props.history.push({
    //     pathname:'/',
    // })
    if(this.interval) {
      clearInterval(this.interval);
    }
  }
  render() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();
    const ymd = year + '年' + month + '月' + day + '日'
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    // let {handleOk} = this.props;
    return (
      <div style={{background:"#FFF", paddingTop: 60, paddingBottom: 50}} onClick={(event)=>{ event.stopPropagation(); return false }} onTouchmove={this.touchmove.bind(this)} onTouchstart={()=> { return false; }} >
        <div style={{textAlign:"center", fontSize:16,fontWeight:"bold", background: "#fff", height: 60, paddingTop: 20, position: "fixed", zIndex: 9999, top: 0, width: "100%" }}>{this.props.title}</div>
        <div style={{background:"#FFF", borderRadius:"20px", position:"relative", padding: 10, paddingTop: 0 }}>
            <div style={{ paddingLeft:"10px", paddingRight:"10px" ,position:"relative"}}>
              <div style={{ fontSize:12, lineHeight:"20px"}}>
                <p style={{textAlign:"center" }}>上海华夏财富投资管理有限公司</p>
                <p style={{textAlign:"center"}}>公开募集证券投资基金投资顾问服务</p>
                <p style={{textAlign:"center"}}>风险揭示书</p>
                <p>尊敬的客户：</p>
                <p style={{ textIndent:"2em" }}>公开募集证券投资基金（以下简称基金）投资顾问服务（以下简称投顾服务）存在风险。为了保护客户的合法权益，特向客户告知如下信息及风险，请客户在接受基金投顾服务前认真阅读：</p>
                <p style={{ textIndent:"2em" }}>一、基金投资顾问业务试点机构（以下简称基金投顾机构）声明与承诺</p>
                <p style={{ textIndent:"2em" }}>基金投顾机构将遵循客户利益优先原则，履行诚实守信、谨慎勤勉、持续注意义务，但不对客户投资收益状况或本金不受损失作出任何承诺，投资风险由客户自行承担。基金投顾服务的过往业绩并不预示其未来业绩表现，为其他客户创造的收益并不构成业绩表现的保证。</p>
                <p style={{ textIndent:"2em" }}>基金投顾服务不同于基金销售业务，其收费模式与基金销售存在较大差异。基金投顾机构可以接受客户委托，按照基金投顾服务协议约定向其提供基金投资组合策略建议，并直接或者间接获取经济利益。客户应充分了解基金投顾服务协议关于收费模式、费用组成、费率水平、计提方式等的安排。</p>
                <p style={{ textIndent:"2em" }}>二、基金投顾服务的一般风险揭示</p>
                <p style={{ textIndent:"2em" }}>（一）基金投顾机构提供的基金投资组合策略建议具有市场风险、信用风险、流动性风险、法律风险以及其他投资风险等。</p>
                <p style={{ textIndent:"2em" }}>1.市场风险</p>
                <p style={{ textIndent:"2em" }}>证券市场价格因受各种因素的影响而引起的波动，将使基金投资组合面临潜在的风险。市场风险可以分为股票投资风险和债券投资风险。</p>
                <p style={{ textIndent:"2em" }}>股票投资风险主要包括：</p>
                <p style={{ textIndent:"2em" }}>（1）国家货币政策、财政政策、产业政策等的变化对证券市场产生一定的影响，导致市场价格水平波动的风险。</p>
                <p style={{ textIndent:"2em" }}>（2）宏观经济运行周期性波动，对股票市场的收益水平产生影响的风险。</p>
                <p style={{ textIndent:"2em" }}>（3）上市公司的经营状况受多种因素影响，如市场、技术、竞争、管理、财务等都会导致公司盈利发生变化，从而导致股票价格变动的风险。</p>
                <p style={{ textIndent:"2em" }}>债券投资风险主要包括：</p>
                <p style={{ textIndent:"2em" }}>（1）市场平均利率水平变化导致债券价格变化的风险。</p>
                <p style={{ textIndent:"2em" }}>（2）债券市场不同期限、不同类属债券之间的利差变动导致相应期限和类属债券价格变化的风险。</p>
                <p style={{ textIndent:"2em" }}>（3）债券之发行人出现违约、拒绝支付到期本息，或由于债券发行人信用质量降低导致债券价格下降的风险。</p>
                <p style={{ textIndent:"2em" }}>2.信用风险</p>
                <p style={{ textIndent:"2em" }}>信用风险是指金融产品发行人未能够实现发行时的承诺，按时足额还本付息的风险，或者交易对手未能按时履约的风险。</p>
                <p style={{ textIndent:"2em" }}>3.流动性风险</p>
                <p style={{ textIndent:"2em" }}>在市场或者投资标的流动性不足的情况下，资产管理人可能无法迅速、低成本地调整基金投资组合，从而对基金投资组合收益造成不利影响。</p>
                <p style={{ textIndent:"2em" }}>由于开放式基金的特殊要求，成分基金必须保持一定的现金比例以应对赎回要求，在管理现金头寸时，有可能存在现金不足的风险和现金过多带来的收益下降风险。</p>
                <p style={{ textIndent:"2em" }}>4.法律风险</p>
                <p style={{ textIndent:"2em" }}>由于各个国家/地区适用不同法律法规的原因，可能导致基金投资组合的某些投资行为在部分国家/地区受到限制或合同不能正常执行，从而使得基金投资组合资产面临损失的可能性。</p>
                <p style={{ textIndent:"2em" }}>5.积极管理风险</p>
                <p style={{ textIndent:"2em" }}>在精选成分基金的实际操作过程中，基金投顾机构可能限于知识、技术、经验等因素而影响其对相关信息、经济形势和证券价格走势的判断，其精选出的成分基金的业绩表现不一定持续优于其他基金。</p>
                <p style={{ textIndent:"2em" }}>6.境外市场投资风险</p>
                <p style={{ textIndent:"2em" }}>成分基金投资境外市场证券的，除了需要承担与境内证券投资基金类似的市场波动风险等一般投资风险之外，成分基金还面临汇率风险等境外证券市场投资所面临的特别投资风险。</p>
                <p style={{ textIndent:"2em" }}>7.其他风险</p>
                <p style={{ textIndent:"2em" }}>由于不可抗力、无法估值、巨额赎回等情形发生，成分基金的基金管理人可按照基金合同、招募说明书等载明的规定暂停接受赎回申请或者延缓支付赎回款项。</p>
                <p style={{ textIndent:"2em" }}>投顾服务的成分基金销售服务由其他基金销售机构提供的，成分基金销售机构将执行基金产品申购、赎回、转换等交易申请，成分基金销售机构可能因违约或其他多种原因导致申购、赎回、转换等交易业务受到限制、暂停或终止，存在影响有效执行基金投资组合策略建议的风险。</p>
                <p style={{ textIndent:"2em" }}>由于战争、自然灾害、罢工、通信技术故障或其他不可预见的意外情况，可能导致基金资产损失。</p>
                <p style={{ textIndent:"2em" }}>（二）基金投顾机构按照客户的风险识别能力、风险承受能力、投资目标等因素，提供不同基金投资组合策略建议，不同基金投资组合策略建议会产生不同的风险收益特征，客户应充分了解基金投资组合策略对应的风险收益等情况。</p>
                <p style={{ textIndent:"2em" }}>基金投顾机构向客户提供基金投资组合策略建议的风险特征与客户购买单只基金不同，可能存在基金投资组合策略成分基金风险等级高于基金投资组合策略风险等级的情况。</p>
                <p style={{ textIndent:"2em" }}>（三）基金投资顾问业务尚处于试点阶段，存在因基金投顾机构的试点资格被取消而不能继续提供服务的风险。</p>
                <p style={{ textIndent:"2em" }}>三、管理型基金投顾服务的特有风险揭示</p>
                <p style={{ textIndent:"2em" }}>（一）账户管理风险：</p>
                <p style={{ textIndent:"2em" }}>1.受基金账户开立失败、成分基金交易限制、系统异常以及其他特殊情况的影响，授权账户可能会出现基金交易失败的情形；</p>
                <p style={{ textIndent:"2em" }}>2.因客户申请转入转出基金投资组合策略时间不同，以及成分基金替代、交易规则差异或限制、实际交易费用，基金投资组合再平衡等原因，客户持有的基金投资组合与基金投资组合策略所对应的标准组合之间可能存在差异，并可能导致业绩表现等方面存在差异；</p>
                <p style={{ textIndent:"2em" }}>3.在授权账户管理运作期间，存在因客户违反反洗钱、反恐怖融资等规定，授权账户被司法冻结或强制执行，导致基金投顾机构无法按照协议约定进行调仓并有效开展基金投资的风险。</p>
                <p style={{ textIndent:"2em" }}>（二）调仓风险：基金投顾机构会根据基金投资组合策略及市场的变化，定期或不定期对每个基金投资组合策略成分基金或其配置比例进行调整，该调整可能会产生费用。</p>
                <p style={{ textIndent:"2em" }}>（三）技术风险：应用互联网技术提供管理型基金投顾服务时，可能出现因重大技术局限和漏洞，导致系统不能为客户提供正常持续服务的风险。</p>
                <p style={{ textIndent:"2em" }}>（四）机构风险：在授权账户管理运作期间，存在因基金投顾机构经营状况恶化、出现声誉风险等情况，导致客户利益受到影响的风险。</p>
                <p style={{ textIndent:"2em" }}>四、其他风险揭示</p>
                <p style={{ textIndent:"2em" }}>本风险揭示书仅包含基金投顾服务可能涉及的部分风险及应知悉的若干重大事项，未穷尽列举基金投顾服务的所有风险及与客户权益相关的一切事项。请客户在完整阅读和理解基金投顾服务相关协议、基金投资组合策略说明书及本风险揭示书的基础上，根据自身风险承受能力和投资需求，审慎决定接受基金投顾服务。</p>
                <p style={{ textIndent:"2em" }}>五、客户声明</p>
                <p style={{ textIndent:"2em" }}>本人已仔细阅读基金投顾服务相关的协议、规则，基金投资组合策略说明书及本风险揭示书，已充分了解并谨慎评估自身风险承受能力，充分理解基金投顾服务所涉及的风险，愿意承担上述风险揭示书中提及的全部风险。</p>
                <div style={{ textIndent:"2em",display:'flex' }}><p style={{width:'55%'}}></p>客户：{this.props.verifiedUserInfo.name}</div>
                <div style={{ textIndent:"2em",display:'flex' }}><p style={{width:'55%'}}></p>日期：{ymd}</div>
              </div>
            </div>
          </div>
          {
            this.state.disabledFlag == false ?
          <div style={{background: "#fff",  height: 50, display:"flex", width:"100%",  justifyContent: "center", alignItems: "center", position: "fixed", bottom: -1, background: "#fff"}} >
                <div onClick={()=>this.goBack()} style={{flex:1,height:"50px",color:"#5c6270",textAlign:'center',lineHeight:'50px'}}>返回</div>
                <div  style={{ width:"100%",flex:5, backgroundColor:"#afb0b2", height:"50px", color:"#FFF", textAlign:"center", lineHeight:"50px" }}>
                {`${this.props.buttonText} (${this.state.disabledNum}s)`}
                </div>
          </div>
          :
          <div style={{ background: "#fff", height: 50, display:"flex", width:"100%",  justifyContent: "center", alignItems: "center", position: "fixed", bottom: -1, background: "#fff"}} >
                <div onClick={()=>this.goBack()} style={{flex:1,height:"50px",color:"#5c6270",textAlign:'center',lineHeight:'50px'}}>返回</div>
                <div onClick={()=>{ this.props.handleOk() }} style={{ width:"100%", flex:5, backgroundColor: "#fa063a", height:"50px", color:"#FFF", textAlign:"center", lineHeight:"50px" }}>
                {`${this.props.buttonText}`}
                </div>
          </div>
          }
        </div>
    );
  }
}

export default AlerModle;


// WEBPACK FOOTER //
// ./src/components/fundDetail/AlerModle.js